import React from 'react';
import { components, NoticeProps } from 'react-select';
import { Loader } from '../../../../components/Loader';
import { Option } from '../types';

export const LoadingMessage: React.FC<NoticeProps<Option>> = (props) => (
  <components.LoadingMessage {...props}>
    <Loader />
  </components.LoadingMessage>
);
